import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import ViewTableInformation from "../../Common/TableRecords/ViewTableInformation";
import ViewTableBodyInformation from "../../Common/TableRecords/ViewTableBodyInformation";
import { UserDetailsSvg } from "../../Common/Assets/SvgIconComponent/CommonSvgIcon";
import messages from '../../../locale/jsonMessages';
import { demoRestrictionEncode } from "../../../helpers/DemoRestriction/demoRestriction";
import { decode } from "../../../helpers/queryEncryption";
import { censorEmail, censorPhone } from "../../../helpers/secureEmail";


const PurchaseServiceUserDetails = (props) => {
    const { data } = props;
    const { formatMessage } = useIntl();
    const [isRestrict, setIsRestrict] = useState(false);
    const dispatch = useDispatch()

    useEffect(() => {
        async function fetchData() {
            const isDemoRestrict = await dispatch(demoRestrictionEncode());
            setIsRestrict(isDemoRestrict);
        }
        fetchData();
    }, []);

    return (
        <ViewTableInformation title={formatMessage(messages.userDetailsLabel)} icon={<UserDetailsSvg />}>
            {(data?.PurchaserData?.firstName) && <ViewTableBodyInformation
                title={formatMessage(messages.userNameLabel)}
                linkText={data?.PurchaserData?.firstName}
                linkData={"/users/show/" + data?.PurchaserData?.profileId}
            />}
            {data?.userType && <ViewTableBodyInformation
                title={formatMessage(messages.userTypeLabel)}
                value={data?.userType === 'renter' ? formatMessage(messages.guest) : formatMessage(messages.hostOption)}
            />}
            {data?.PurchaserData?.phoneNumber && <ViewTableBodyInformation
                title={formatMessage(messages.phoneNumber)}
                value={`${data?.PurchaserData?.countryCode && data?.PurchaserData?.countryCode} ${isRestrict ? censorPhone(decode(data?.PurchaserData?.phoneNumber)) : decode(data?.PurchaserData?.phoneNumber)}`}
            />}
            {data?.purchaserEncryptEmail && <ViewTableBodyInformation
                title={formatMessage(messages.emailLabel)}
                value={isRestrict ? censorEmail(decode(data?.purchaserEncryptEmail)) : decode(data?.purchaserEncryptEmail)}
            />}
        </ViewTableInformation>
    )
}

export default PurchaseServiceUserDetails;
